import script from "./MypageApiManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./MypageApiManagement.vue?vue&type=script&setup=true&lang=ts"

import "./mypage.css?vue&type=style&index=0&id=12aa1063&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12aa1063"]])

export default __exports__